<template>
  <div
    class="front-product front-container d-flex justify-content-center align-items-center"
  >
    <div class="d-flex justify-content-center align-items-center">
      <div class="d-flex justify-content-center align-items-center">
        <img :src="product.imageUrl" alt="" />
      </div>
      <div class="product-info">
        <ul class="d-flex flex-column">
          <li class="title">{{ product.title }}</li>
          <li>{{ product.content }}</li>
          <li>原價:{{ $money(product.origin_price) }}</li>
          <li>特價:{{ $money(product.price) }}</li>
          <li>詳細內容: {{ product.description }}</li>
          <li>
            <el-select v-model="productNumber" placeholder="請選擇">
              <el-option
                v-for="index in 100"
                :key="index"
                :label="index + product.unit"
                :value="index"
              >
              </el-option>
            </el-select>
          </li>
          <li class="align-self-end  mt-auto">
            <button @click="addToCartHandler(product.id)">
              加入購物車
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import frontProductRequest from '@/assets/js/api/front/apiFrontProduct';
import apiFrontCart from '@/assets/js/api/front/apiFrontCart';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      productNumber: '',
      product: {},
    };
  },
  created() {
    const { id } = this.$route.params;
    frontProductRequest.get(`${id}`).then(res => {
      let { data } = res.data;
      this.product = data;
    });
  },
  methods: {
    ...mapActions(['setCartLength']),
    addToCartHandler(id) {
      let vm = this;
      if (!this.productNumber) {
        this.$fire({
          type: 'error',
          title: `請選擇數量`,
          timer: 3000,
        });
        return;
      }
      apiFrontCart
        .post('', {
          product: id,
          quantity: this.productNumber,
        })
        .then(res => {
          if (res.status == 200) {
            this.$fire({
              title: `新增成功`,
              type: 'success',
              timer: 3000,
            });
            vm.setCartLength();
          }
        })
        .catch(() => {
          this.$fire({
            title: `已在購物車中`,
            type: 'error',
            timer: 3000,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
